import React from "react";
import Layout from "src/components/layout/website/Layout";
import { SITE_SETTINGS } from "src/constants/common";
import { PAGE_SEO } from "src/constants/seo";

// TODO(legal): Add the registered business address once the entity is
// registered, and have this reviewed by a lawyer before onboarding customer
// data at scale.
const PrivacyPage: React.FC = () => {
  return (
    <Layout meta={PAGE_SEO.privacy}>
      <div className="min-h-screen bg-white py-16 px-6 max-w-5xl mx-auto">
        <h1 className="text-3xl font-bold text-indigo-600 mb-2">
          Privacy Policy
        </h1>
        <p className="text-gray-500 text-sm mb-6">
          Last updated: September 15, 2026
        </p>

        <p className="text-gray-600 mb-6">
          Invyntra ("we", "us", "our") provides a cloud-based inventory
          management platform ("Service"). This policy explains what data we
          collect, why, and how it's handled when you use our website or
          Service.
        </p>

        <h2 className="font-semibold text-lg text-gray-800 mt-8 mb-2">
          1. What we collect
        </h2>
        <ul className="list-disc ml-6 text-gray-600 space-y-2">
          <li>
            Account information you provide, such as name, email, mobile
            number, and business details.
          </li>
          <li>
            Business data you enter into the platform — products, stock,
            purchases, sales, suppliers, and customers.
          </li>
          <li>
            Basic usage data (pages visited, actions taken) to help us fix
            bugs and improve the product.
          </li>
        </ul>

        <h2 className="font-semibold text-lg text-gray-800 mt-8 mb-2">
          2. How we use it
        </h2>
        <ul className="list-disc ml-6 text-gray-600 space-y-2">
          <li>To provide and operate the Service you've signed up for.</li>
          <li>To respond to support requests you submit to us.</li>
          <li>
            To improve reliability and features, using aggregated or
            anonymized usage patterns where possible.
          </li>
        </ul>

        <h2 className="font-semibold text-lg text-gray-800 mt-8 mb-2">
          3. Sharing
        </h2>
        <p className="text-gray-600 mb-2">
          We do not sell your data. We share data only with:
        </p>
        <ul className="list-disc ml-6 text-gray-600 space-y-2">
          <li>
            Infrastructure providers we use to run the Service (e.g. our
            hosting provider), solely to operate the platform.
          </li>
          <li>Authorities, if required by law.</li>
        </ul>

        <h2 className="font-semibold text-lg text-gray-800 mt-8 mb-2">
          4. Data storage &amp; security
        </h2>
        <p className="text-gray-600 mb-6">
          Data is transmitted over encrypted connections (HTTPS). We take
          reasonable technical and organizational measures to protect your
          data, but no online service can guarantee absolute security.
        </p>

        <h2 className="font-semibold text-lg text-gray-800 mt-8 mb-2">
          5. Your rights
        </h2>
        <p className="text-gray-600 mb-6">
          You can request access to, correction of, or deletion of your
          personal data at any time by writing to{" "}
          <span className="text-indigo-600">
            {SITE_SETTINGS.CONTACT_EMAIL}
          </span>
          . We'll respond within a reasonable time.
        </p>

        <h2 className="font-semibold text-lg text-gray-800 mt-8 mb-2">
          6. Data retention
        </h2>
        <p className="text-gray-600 mb-6">
          We retain account and business data for as long as your account is
          active. If you close your account, we'll delete or anonymize your
          data within a reasonable period, except where we're required to
          retain it by law.
        </p>

        <h2 className="font-semibold text-lg text-gray-800 mt-8 mb-2">
          7. Changes to this policy
        </h2>
        <p className="text-gray-600 mb-6">
          We may update this policy as the product evolves. Material changes
          will be notified to registered users; continued use of the Service
          after changes take effect means you accept the updated policy.
        </p>

        <h2 className="font-semibold text-lg text-gray-800 mt-8 mb-2">
          8. Contact
        </h2>
        <p className="text-gray-600">
          Questions about this policy can be sent to{" "}
          <span className="text-indigo-600">
            {SITE_SETTINGS.CONTACT_EMAIL}
          </span>
          .
        </p>
      </div>
    </Layout>
  );
};

export default PrivacyPage;
